export const miniRadius = 4;
export const buttonRadius = 8;
export const containerRadius = 12;
export const dialogRadius = 16;
export const squareRadius = 0;
export const circularRadius = 9999;

export const radii = {
  mini: `${miniRadius}px`,
  button: `${buttonRadius}px`,
  container: `${containerRadius}px`,
  dialog: `${dialogRadius}px`,
  square: `${squareRadius}px`,
  circular: `${circularRadius}px`,
};
